export const createTenantJsonBuilder = (tenant, state) => ({
  ...state,
  accountId: tenant.accountId,
  tenantType: parseInt(state.tenantType),
});
